import React from 'react';
import Logo from './../assets/images/logo_overview.png';
import User from './../assets/images/user.jpg';
import './../css/overview.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faChartBar, faTags } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import Internalservererror from './../assets/images/internal_server_error.png';
import { useDispatch, useSelector } from 'react-redux';
import amplitude from 'amplitude-js';

const InternalServerError = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const onLogout = () => {
    localStorage.removeItem('email');
    localStorage.removeItem('id');
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('distance');

    dispatch({
      type: 'LOGOUT',
    });

    amplitude.getInstance().clearUserProperties();

    window.location.reload();
  };

  const userProfile = useSelector((state) => state.user.user_profile);

  return (
    <div className="overview-page">
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <a className="navbar-brand" href="#">
          <img
            style={{
              marginLeft: 30,
            }}
            src={Logo}
            alt="logo"
          />
        </a>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto ml-5">
            <li className="nav-item active">
              <h5
                style={{
                  marginLeft: 70,
                }}
              >
                Market Auction Price
              </h5>
            </li>
          </ul>
          {
            localStorage.getItem('id') == null || !userProfile ? (
              <form className="form-inline my-2 my-lg-0">
                <button
                  onClick={() => {
                    history.push('/login', { pageChannel: 'Internal Server Error Page' });
                  }}
                  className="my-2 my-sm-0 mr-3"
                  type="submit"
                  style={{
                    width: 100,
                    border: 0,
                    color: '#82be2a',
                    background: 'white',
                  }}
                >
                  Masuk
                </button>
                <button
                  onClick={() => {
                    history.push('/register', {
                      pageChannel: 'Internal Server Page',
                    });
                  }}
                  className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
                  type="submit"
                  style={{ width: 100 }}
                >
                  Daftar
                </button>
              </form>
            ) : (
              <div className="btn-group mr-2">
                <button
                  style={{ border: 0, backgroundColor: '#ffffff' }}
                  className="text-black"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div>
                    <label className="mr-4 mt-1">{userProfile.users.Name}</label>
                    <img src={User} width={30} height={30} alt={userProfile.users.Name} />
                  </div>
                </button>
                <div className="dropdown-menu dropdown-menu-right" style={{ width: 300 }}>
                  <div className="px-4 pt-2">
                    <b>{userProfile.users.Name}</b>
                    <br />
                    <label>{userProfile.users.Email}</label>
                  </div>
                  <hr />
                  <button className="dropdown-item" type="button">
                    Profile
                  </button>
                  <hr />
                  <button className="dropdown-item text-danger" onClick={onLogout} type="button">
                    keluar
                  </button>
                </div>
              </div>
            )

          }
        </div>
      </nav>
      <div className="container-fluid main-overview">
        <div className="row" style={{ height: '90vh' }}>
          <div className="col-xl-2 d-xl-block d-none side-nav pt-3 bg-primary">
            <a href="">
              <div>
                <FontAwesomeIcon style={{ marginRight: 10 }} icon={faHome} />
                Overview
              </div>
            </a>
            <a href="insights">
              <div>
                <FontAwesomeIcon style={{ marginRight: 10 }} icon={faChartBar} />
                Insights
              </div>
            </a>
            <a href="marketprice-db">
              <div>
                <FontAwesomeIcon style={{ marginRight: 10 }} icon={faTags} />
                Market Price DB
              </div>
            </a>
          </div>
          <div className="col-xl-10 p-3 content">
            <div
              className="card text-center d-flex justify-content-center align-items-center"
              style={{ height: '90vh' }}
            >
              <img src={Internalservererror} height="300" width="500" alt='Terjadi Gangguan' />
              <h5 style={{ color: '#3c64b1' }}>Terjadi Gangguan</h5>
              <h6 className="mb-4">Mohon maaf, kami akan segera kembali</h6>
              <button
                onClick={() => {
                  history.push({ pathname: '/', state: { pageChannel: 'Internal Server Error Page' } });
                }}
                className="btn-overview-green-solid-hovered my-2 my-sm-0 mr-3"
                type="submit"
                style={{ width: 200 }}
              >
                Kembali ke Halaman Utama
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalServerError;
